import { type SVGProps } from 'react';

const CrossIcon = ({
  width = '8',
  height = '8',
  className = '',
  color = '',
}: SVGProps<SVGSVGElement>) => (
  <svg
    width={width}
    height={height}
    className={className}
    color={color}
    fill="none"
    viewBox="0 0 8 8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 3.11125L7.11125 0L8 0.888749L4.88875 4L8 7.11125L7.11125 8L4 4.88875L0.888749 8L0 7.11125L3.11125 4L0 0.888749L0.888749 0L4 3.11125Z"
      fill="currentColor"
    />
  </svg>
);

export default CrossIcon;
